import React from 'react'
import { CheckItem, HazardLevel } from '@/types'
import { CheckItemCard } from '@/components/CheckItemCard'

interface HazardGroupProps {
  title: string
  level: HazardLevel
  items: CheckItem[]
  checkedItems: string[]
  onToggle: (item: CheckItem) => void
  onDelete?: (item: CheckItem) => void
}

export const HazardGroup: React.FC<HazardGroupProps> = ({
  title,
  level,
  items,
  checkedItems,
  onToggle,
  onDelete,
}) => {
  const isMajor = level === HazardLevel.MAJOR
  const checkedCount = items.filter((item) => checkedItems.includes(item.id)).length

  if (items.length === 0) return null

  return (
    <div className="mb-6">
      {/* 分组标题 */}
      <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border-b border-gray-200">
        <div className="flex items-center">
          <div
            className={`w-1.5 h-5 rounded mr-2 ${
              isMajor ? 'bg-red-600' : 'bg-orange-500'
            }`}
          />
          <span className="text-base font-medium text-gray-800">{title}</span>
        </div>
        <div
          className={`text-sm ${
            checkedCount > 0
              ? isMajor
                ? 'text-red-600 font-medium'
                : 'text-orange-500 font-medium'
              : 'text-gray-400'
          }`}
        >
          已选 {checkedCount}/{items.length} 项
        </div>
      </div>

      {/* 检查项目列表 */}
      <div className="bg-white">
        {items.map((item) => (
          <CheckItemCard
            key={item.id}
            item={item}
            checked={checkedItems.includes(item.id)}
            onToggle={onToggle}
            onDelete={onDelete}
          />
        ))}
      </div>
    </div>
  )
}
